/* eslint-disable react/prop-types */
import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react'

export const TabContext = createContext({})

export const useTabContext = () => {
  const provided = useContext(TabContext)
  return provided
}

export function TabProvider({ tabs, children, initialTabId = null }) {
  const getInitialTabId = useCallback(() => initialTabId || tabs?.[0]?.key || null, [tabs, initialTabId])
  const [activeTab, setActiveTab] = useState(getInitialTabId())

  // Update activeTab when tabs change (e.g., when modal opens with new tabs)
  useEffect(() => {
    setActiveTab(getInitialTabId)
  }, [getInitialTabId])

  const provided = useMemo(
    () => ({
      tabs,
      activeTab,
      setActiveTab,
    }),
    [tabs, activeTab],
  )

  return <TabContext.Provider value={provided}>{children}</TabContext.Provider>
}

export function TabSwitch(props) {
  const { children, tab } = props
  const { activeTab } = useTabContext()

  if (activeTab && activeTab !== tab) {
    return null
  }

  return children
}
